// src/authConfig.js
export const msalConfig = {
    auth: {
      //authority: "https://login.microsoftonline.com/c4484a25-d0d8-4ad0-916a-a889b6aa7a02", // From Azure AD Tenant
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ROSTER_TENANTID}`, // From Azure AD Tenant

      //clientId: "76d0c2b3-aa67-4b00-9966-cb9784d21cda", // From Azure AD App Registration - ENG-Roster-VendorPortal-azapp-72 Use this one for external
      clientId: `${process.env.REACT_APP_ROSTER_CLIENTID}`, // From Azure AD Tenant
      
      //redirectUri: "https://dev.engvendor.panynj.gov",      // Dev Site - Web App
      //redirectUri: "https://qa.engvendor.panynj.gov"   // QA site - Web App
      redirectUri: "https://engvendor.panynj.gov"   // Prod site - Web App
      //redirectUri: "http://localhost:3000/"
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
  };
  
  export const loginRequest = {
    scopes: ["User.Read", "Directory.Read.All", `api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`] // Request the custom API scope
    //scopes: ["Directory.Read.All"],
  };
  